import { DefaultState } from 'store/types';

export const GET_ACTIVE_RESERVATIONS_COUNT_DATA_REQUEST = 'GET_ACTIVE_RESERVATIONS_COUNT_DATA_REQUEST';
export const GET_ACTIVE_RESERVATIONS_COUNT_DATA_SUCCESS = 'GET_ACTIVE_RESERVATIONS_COUNT_DATA_SUCCESS';
export const GET_ACTIVE_RESERVATIONS_COUNT_DATA_FAILURE = 'GET_ACTIVE_RESERVATIONS_COUNT_DATA_FAILURE';

export type GetActiveReservationsCountState = DefaultState & {
  contents: number;
};

interface ReadGetActiveReservationsCountDataRequest {
  type: typeof GET_ACTIVE_RESERVATIONS_COUNT_DATA_REQUEST;
}

interface ReadGetActiveReservationsCountDataSuccess {
  type: typeof GET_ACTIVE_RESERVATIONS_COUNT_DATA_SUCCESS,
  contents: number;
}

interface ReadGetActiveReservationsCountDataFailure {
  type: typeof GET_ACTIVE_RESERVATIONS_COUNT_DATA_FAILURE;
}

export type GetActiveReservationsCountActionTypes = ReadGetActiveReservationsCountDataRequest | ReadGetActiveReservationsCountDataSuccess | ReadGetActiveReservationsCountDataFailure;